"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.typed.uint8-array");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BackgroundComponent',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      id: null,
      // 预览弹窗相关
      previewVisible: false,
      previewImageUrl: '',
      formData: {
        color: '#409eff'
      }
    };
  },
  created: function created() {
    // 组件创建时可以访问到传入的key值
    console.log('BackgroundComponent - pageKey:', this.pageKey, 'moduleKey:', this.moduleKey);
    // 页面加载时获取已保存的配置
    this.loadConfig();
  },
  methods: {
    // 确认保存
    confirmSave: function confirmSave() {
      var _this = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this.$message.info('已取消保存');
      });
    },
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _loading, response, configInfo, parsedConfig, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              // 显示加载loading状态
              _loading = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口获取配置
              _context.next = 2;
              return (0, _decorateConfig.getDecorateConfig)(this.pageKey, this.moduleKey);
            case 2:
              response = _context.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200 && response.data) {
                // 保存ID
                this.id = response.data.id;

                // 解析配置信息
                configInfo = response.data.configInfo;
                if (configInfo) {
                  // 将JSON字符串转换为对象
                  parsedConfig = typeof configInfo === 'string' ? JSON.parse(configInfo) : configInfo; // 更新表单数据
                  if (parsedConfig.backgroundConfig) {
                    this.formData = parsedConfig.backgroundConfig;
                  }
                }
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              // 如果response.data为空，说明还没有保存过配置，使用默认值
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('配置加载失败:', _t);
              this.$message.error('配置加载失败: ' + (_t.message || '未知错误'));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 3]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 保存配置
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var config, data, _loading2, response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              config = {
                backgroundConfig: this.formData
              };
              data = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                configInfo: JSON.stringify(config)
              }; // 显示保存loading状态
              _loading2 = this.$loading({
                lock: true,
                text: '保存中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口保存配置
              _context2.next = 1;
              return (0, _decorateConfig.saveDecorateConfig)(data);
            case 1:
              response = _context2.sent;
              // 关闭loading
              _loading2.close();
              if (response.code === 200) {
                this.$message.success('保存成功');
                // 保存成功后更新ID
                if (response.data && response.data.id) {
                  this.id = response.data.id;
                }
              } else {
                this.$message.error(response.message || '保存失败!');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('保存失败:', _t2);
              this.$message.error('保存失败: ' + (_t2.message || '未知错误'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 预览配置
    handlePreview: function () {
      var _handlePreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var config, configInfo, _loading3, response, blob, _blob, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              config = {
                backgroundConfig: this.formData
              }; // 将配置转换为JSON字符串
              configInfo = {
                id: this.id,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                previewConfigInfo: JSON.stringify(config)
              }; // 显示预览loading状态
              _loading3 = this.$loading({
                lock: true,
                text: '预览中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口预览配置
              _context3.next = 1;
              return (0, _decorateConfig.previewDecorateConfigInfo)(configInfo, this.xcxType);
            case 1:
              response = _context3.sent;
              // 关闭loading
              _loading3.close();
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有图片URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了图片URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  }
                  // 检查是否返回了字节数组
                  else if (response.data.image && response.data.image instanceof Array) {
                    // 将字节数组转换为Blob URL
                    blob = new Blob([new Uint8Array(response.data.image)], {
                      type: 'image/png'
                    });
                    this.previewImageUrl = URL.createObjectURL(blob);
                    this.previewVisible = true;
                  }
                  // 检查data本身是否就是字节数组
                  else if (response.data instanceof Array) {
                    _blob = new Blob([new Uint8Array(response.data)], {
                      type: 'image/png'
                    });
                    this.previewImageUrl = URL.createObjectURL(_blob);
                    this.previewVisible = true;
                  } else {
                    this.$message.success('背景配置预览成功');
                  }
                } else {
                  this.$message.success('背景配置预览成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('预览失败:', _t3);
              this.$message.error('预览失败: ' + (_t3.message || '未知错误'));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handlePreview() {
        return _handlePreview.apply(this, arguments);
      }
      return handlePreview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 组件销毁前释放资源
    beforeDestroy: function beforeDestroy() {
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 应用配置
    handleApply: function handleApply() {
      var config = {
        backgroundConfig: this.formData
      };
      console.log('应用背景配置:', config);
      this.$message.success('背景配置应用成功');
    }
  }
};